import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DateRange } from '@mui/x-date-pickers-pro';
import { PickersShortcutsItem } from '@mui/x-date-pickers/PickersShortcuts';

dayjs.extend(utc);

const currentDate = dayjs().utc();

interface IPredefinedDateRange {
  label: string;
  value: [Dayjs, Dayjs];
  placement: string;
  id: number;
  isDefault?: boolean;
}

export const predefinedDateRanges: IPredefinedDateRange[] = [
  {
    label: 'Last day',
    value: [currentDate.subtract(1, 'day').startOf('day'), currentDate.subtract(1, 'day').endOf('day')],
    placement: 'left',
    id: 1,
  },
  {
    label: 'Last week',
    value: [
      currentDate.subtract(1, 'week').startOf('week').add(1, 'day').startOf('day'),
      currentDate.subtract(1, 'week').endOf('week').add(1, 'day').startOf('day'),
    ],
    placement: 'left',
    id: 2,
  },
  {
    label: 'Last month',
    value: [currentDate.subtract(1, 'month').startOf('month'), currentDate.subtract(1, 'month').endOf('month')],
    placement: 'left',
    id: 3,
  },
  {
    label: 'This month',
    value: [currentDate.startOf('month'), currentDate.endOf('month').subtract(1, 'day')],
    placement: 'left',
    id: 4,
    isDefault: true,
  },
  {
    label: 'This year',
    value: [currentDate.startOf('year'), currentDate.endOf('year')],
    placement: 'left',
    id: 5,
  },
];

interface IShortcutsItem extends PickersShortcutsItem<DateRange<Dayjs>> {
  id: number;
}

export const shortcutsItems: IShortcutsItem[] = predefinedDateRanges.map(dateRange => {
  return {
    ...dateRange,
    getValue: () => {
      return [dayjs(dateRange.value[0]), dayjs(dateRange.value[1])];
    },
  };
});
